import { Theme, useStyles } from 'bold-ui'
import React, { CSSProperties } from 'react'

export interface PageContainerProps {
  fluid?: boolean
  children?: React.ReactNode
}

export function PageContainer(props: PageContainerProps) {
  const { fluid, children } = props
  const { classes, css } = useStyles(createStyles)

  return <div className={css(classes.container, fluid && classes.fluid)}>{children}</div>
}

export const createStyles = (theme: Theme) => ({
  container: {
    width: '100%',
    margin: '0 auto',
    padding: '0 2rem',
    maxWidth: 'calc(1120px + 4rem)',
  } as CSSProperties,
  fluid: {
    width: '100%',
    maxWidth: '1600px',
  },
})
